/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import wretch from "wretch";
import { currentUser } from "@quintype/bridgekeeper-js";
import get from "lodash/get";

import { renderApplication, preRenderApplication } from "./render";
import { REDUCERS } from "../isomorphic/components/store/reducers";
import { MEMBER_UPDATED, AUTH_INITIALIZATION_STARTED, AUTH_INITIALIZATION_COMPLETED } from "../isomorphic/components/store/actions";
import "../../app/assets/stylesheets/app.scss";

const opts = {
  enableServiceWorker: true,
  appVersion: require("../isomorphic/app-version"),
  preRenderApplication
};

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => {
      renderApplication(store);
      preRenderApplication(store);
    });
  }
}

if (window.OneSignal) {
  Object.assign(opts, {
    serviceWorkerLocation: "/OneSignalSDKWorker.js"
  });
}

global.wretch = wretch;

// Fix for browser back/forward navigation
// Disable automatic scroll restoration to prevent issues with AJAX navigation
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Initialize authentication state on app start
async function initializeAuth(store) {
  store.dispatch({ type: AUTH_INITIALIZATION_STARTED });

  try {
    const currentUserResp = await currentUser();
    if (currentUserResp && get(currentUserResp, ["user"], null)) {
      store.dispatch({
        type: MEMBER_UPDATED,
        member: get(currentUserResp, ["user"], null)
      });
    }
  } catch (error) {
    // User is not logged in or there's an error - this is normal
    console.debug("No current user session found");
  } finally {
    store.dispatch({ type: AUTH_INITIALIZATION_COMPLETED });
  }
}

startApp(renderApplication, REDUCERS, opts).then((store) => {
  enableHotReload(store);
  initializeAuth(store);
});
